import React from "react";

export default function Header() {
  return (
    <div>
      <h1 className="ext-gray-800 text-3xl ">Grocery List</h1>
    </div>
  );
}
